export const GET_USER_VAULTS = 'GET_USER_VAULTS';
export const SET_USER_VAULTS = 'SET_USER_VAULTS';
export const GET_ASSETS_TO_VAULTS = 'GET_ASSETS_TO_VAULTS';
export const GET_MARGIN_ACCOUNTS = 'GET_MARGIN_ACCOUNTS';
export const SET_USER_MARGIN_ACCOUNTS = 'SET_USER_MARGIN_ACCOUNTS';
